import { HomeOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./cash.scss";
import WalletLayout from "../../wallet-layout";
import { Breadcrumb, Button, Col, Form, Input, Row, Tooltip } from "antd";
import { _adr } from "../../../../address";
import { Content } from "antd/es/layout/layout";
import {
  commaDigits,
  complexDigitToman,
  convertCurrencyToRial,
  convertCurrencyToToman,
  convertToJalaliWithoutTime,
  regexFormater,
  validateInput,
} from "../../../../tools/tools";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAPIPublic } from "../../../../tools/api";
import { useSelector } from "react-redux";
const WalletCash = () => {
  const [t] = useTranslation("global");
  const { queryMinimumAmountGetCashFromWallet, withdrawUserWallet } = useAPIPublic();

  const { _currentUser } = useSelector((state) => state?.another);
  const nav = useNavigate();
  const [frmWithDrawal] = Form.useForm();

  const [minimumAmount, setMinimumAmount] = useState(0);

  const [acceptForPayment, setAcceptForPayment] = useState(false);
  const [priceForPayment, setPriceForPayment] = useState(0);

  useEffect(() => {
    const initialGetService = async () => {
      let response = await queryMinimumAmountGetCashFromWallet();
      setMinimumAmount(response);
      frmWithDrawal.setFieldValue("bankaccountnumber", _currentUser?.bankaccountnumber);
    };
    initialGetService();
  }, []);

  const handleComma = (e) => {
    let v = e.target.value;
    if (e.target.value.length > 0 && !isNaN(parseInt(e.target.value))) {
      v = commaDigits(parseInt(e.target.value.replace(/,/g, "")) / 1);
      e.target.value = v;
      return v;
    } else {
      return "";
    }
  };
  const handleSubmit = async (values) => {
    if (acceptForPayment) {
      let payload = {
        amount: priceForPayment,
      };
      let response = await withdrawUserWallet(payload);
      if (response) {
        nav(_adr.Root + _adr.Wallet.Index + _adr.Wallet.Withdraw.Index + _adr.Wallet.Withdraw.Final, { state: { ...response } });
      }
    } else {
      setPriceForPayment(convertCurrencyToRial(regexFormater(values.amount).removeComma()));
      setAcceptForPayment(true);
    }
  };
  return (
    <WalletLayout>
      <div className="g-hold-title-of-page">
        <Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("wallet.withdrawal") }]} />
        <div className="title-page">
          <h3>{t("wallet.withdrawal")}</h3>
          <p></p>
        </div>
      </div>
      <div className="g-layout-content">
        <Content className="g-layout-main wa-container">
          <div className="g-format-page">
            <div className="g-body-format-page">
              <div className="holder-withDrawal">
                <Form id="frmWithDrawal" form={frmWithDrawal} layout="vertical" onFinish={handleSubmit}>
                  <Row gutter={30}>
                    <Col span={8} xl={8} lg={10} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="input-normal"
                        label="مبلغ (تومان)"
                        name="amount"
                        rules={[
                          validateInput({
                            t: t,
                            validate: true,
                            type: "chargeWallet",
                            priceAmount: convertCurrencyToToman(minimumAmount),
                          }),
                        ]}
                        extra={
                          <>
                            <p>
                              مبلغ قابل برداشت: <span dir="ltr">{complexDigitToman(_currentUser?.walletAmount - minimumAmount)}</span> تومان{" "}
                              <Tooltip title={`حداقل مانده کیف پول میبایست ${complexDigitToman(minimumAmount)} هزار تومان باشد`}>
                                <InfoCircleOutlined />
                              </Tooltip>
                            </p>
                          </>
                        }
                      >
                        <Input
                          disabled={acceptForPayment ? true : false}
                          onInput={handleComma}
                          onPaste={(e) => e.preventDefault()}
                          maxLength="10"
                          dir="ltr"
                          autoComplete="off"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8} xl={8} lg={10} md={12} sm={24} xs={24}>
                      <Form.Item className="input-normal" name="bankaccountnumber" label="انتخاب شماره حساب">
                        <Input disabled dir="ltr" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                {acceptForPayment && (
                  <div className="holder-withDrawal-price">
                    <p>
                      مبلغ <span className="result-sucess">{complexDigitToman(priceForPayment)}</span> تومان از کیف پول شما در تاریخ{" "}
                      <span className="result-sucess">{convertToJalaliWithoutTime(new Date().toISOString())}</span> با کسر کارمزد به شماره شبای{" "}
                      <span className="result-sucess">{_currentUser?.shebanumber}</span> در صورت تایید کارشناسان واریز می گردد.
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="g-footer-format-page">
              <div className="holder-button">
                <Button form="frmWithDrawal" key="submit" htmlType="submit" className="btn-normal btn-aptel" type="primary" danger>
                  {acceptForPayment ? <>تایید و پرداخت</> : <>مرحله بعد</>}
                </Button>
                <Button className="btn-normal" onClick={() => nav(_adr.Root + _adr.Wallet.Index)}>
                  بازگشت
                </Button>
              </div>
            </div>
          </div>
        </Content>
      </div>
    </WalletLayout>
  );
};

export default WalletCash;
